import React from "react";

import range from "lodash/range";

import * as DetailList from "~/components/DetailList";
import Skeleton from "~/components/Skeleton";

export default function SkeletonDetailList({
  count,
  mobile = 12,
  tablet = 6,
  desktop = 3,
  widescreen = undefined,
  ...props
}: any) {
  return (
    <DetailList.Content {...props}>
      {range(count).map((i) => (
        <DetailList.Item key={i} {...{ mobile, tablet, desktop, widescreen }}>
          <DetailList.Term>
            <Skeleton count={1} />
          </DetailList.Term>
          <DetailList.Description>
            <Skeleton count={1} />
          </DetailList.Description>
        </DetailList.Item>
      ))}
    </DetailList.Content>
  );
}
